
<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard class='tablewrapper'>
            <CCardHeader>
              <CIcon name="cil-grid"/> 従業員管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol sm="2">
                </CCol>
                <CCol sm="4">
                </CCol>
                <CCol sm="2">
                </CCol>
                <CCol sm="2">
                </CCol>
                <CCol sm="2">
                  <CButton color="info" class="mt-4" @click='showRecordModal({},0, "Create")'>新規作成</CButton>
                </CCol>
              </CRow>
              <div class="row my-2 mx-0">
                <div class="col-sm-6 form-inline p-0">
                  <label class="mr-2">Filter:</label>
                  <input type="text" placeholder="type string..." class="form-control" v-model="searchKeyWord">
                </div>
              </div>
              <CDataTable
                :hover="true"
                :striped="true"
                :items="items"
                :loading="isLoading"
                :fields="fields"
                :itemsPerPage="20"
                pagination
                class='table-scroll'
              >
                 <template #created_at="{row}">
                  <td class="py-2">
                    {{ formatDate(row) }}
                  </td>
                </template>
                 <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton class="mr-2" color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>
                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      v-model="page"
                      :page-count="meta.total_pages"
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>

              </CDataTable>

            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
    >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label pt-3">名前</label>
           <CInput placeholder="名前" v-model="record.name" :class="{ 'hasError': $v.record.name.$error }"/>

           <small v-if="$v.record.name.$error" class="errorLabel">名前を入れてください</small>
         </CCol>

         <CCol sm="12">
           <label class="record-label pt-3">メールアドレス</label>
           <CInput placeholder="email" v-model="record.email" :class="{ 'hasError': $v.record.email.$error }" />
           <small v-if="$v.record.email.$error" class="errorLabel">メールアドレスを入れてください</small>
         </CCol>


         <CCol sm="12">
           <label class="record-label pt-3">電話番号</label>
           <CInput v-model="record.phone" />
         </CCol>

         <CCol sm="12" v-if="record.id == null">
           <label class="record-label pt-3">パスワード</label>
           <CInput v-model="record.password" :class="{ 'hasError': $v.record.password.$error }" />
           <small v-if="$v.record.password.$error" class="errorLabel">パスワードを入れてください</small>
         </CCol>


         <CCol sm="12">
           <label class="record-label pt-3">所属法人</label>
           <CSelect
             placeholder="所属法人を選択してください"
             :class="{ 'hasError': $v.record.company_id.$error }"
             :options="companyTypes"
             :value.sync="record.company_id"
           />
           <small v-if="$v.record.company_id.$error" class="errorLabel">所属法人を入れてください</small>
         </CCol>

       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem(mode, itemIndex)">登録</CButton>
       </template>
    </CModal>

    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この従業員を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>




  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {Paginate},
  data() {
    return {
      isLoading: false,
      mode: 'Create',
      record: {},
      recordModal: false,
      deleteModal: false,
      itemIndex: 0,
      items: [],
      filter_cs: [],
      filter_vs: [],
      companyTypes: [],
      page: 1,
      word: "",
      sort_column: "id",
      sort_asc: "desc",
      select_gender: '',
      select_status: '',
      meta: {},
      fields: [
        { key: 'name', label: "名前"},
        { key: 'email', label: "メールアドレス"},
        { key: 'phone', label: "電話番号"},
        { key: 'company_id', label: "所属法人ID"},
        { key: 'company_name', label: "所属法人名"},
        { key: 'created_at', label: "作成日時"},
        { key: 'show_details', label: '',  _style: 'width:15%', sorter: false, filter: false},
      ],
      searchKeyWord: "",
      isSearching: false,
    }
  },
  validations: {
    record: {
      name: {required},
      email: {required},
      password: {required},
      company_id: {required}
    }
  },
  methods: {
    formatDate: function(d) {
        return moment(d).format("YYYY年MM月DD日 HH:mm")
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規法人追加" : "編集"
    },
    showRecordModal: function(i, index, mode="Edit") {
      this.recordModal = true
      this.record = JSON.parse(JSON.stringify(i))

      this.mode = mode
      this.itemIndex = index
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = JSON.parse(JSON.stringify(i))
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/api/mng/employees/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.items.splice(this.itemIndex, 1)
        }).catch(error => {
          this.deleteModal = false
          this.errorNotify(error.response)
        })
    },
    updateItem: function(mode="Create", index=0) {
      // this.$v.record.$touch();
      // if(this.$v.record.$error) return

      if(mode == "Create") {
        console.log(this.record)
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/api/mng/employees", {"employee": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.recordModal = false
            this.items.push(response.data)
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/api/mng/employees/" + this.record.id, {"employee": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then((response) => {
            this.record = response.data
            this.recordModal = false
            this.$set(this.items, index, JSON.parse(JSON.stringify(this.record)))
          }).catch(error => {
            this.recordModal = false
            this.errorNotify(error.response)
          })
      }
    },
    paging: function(n) {
      if(this.isSearching) {
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/employees?&key_word=" + encodeURIComponent(this.word) + "&page=" + n + "&column=" + this.sort_column + "&direction=" + this.sort_asc)
          .then(response => {
              this.items = response.data.employees
              this.meta = response.data.meta
          }).catch(error => {
              this.errorNotify(error.response)
          })
      } else {
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/employees?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
              this.items = response.data.employees
              this.meta = response.data.meta
          }).catch(error => {
              this.errorNotify(error.response)
          })
      }  
    },

    search: function(key_word) {
      if(key_word != "") {
        this.isSearching = true;
        this.page = 1;
        this.word = key_word
        if(key_word == "-") {
          this.word = ""
        }
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/employees?&key_word=" + encodeURIComponent(this.word) + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.items = response.data.employees
            this.meta = response.data.meta
          }).catch(error => {
              this.errorNotify(error.response)
          })
      } else {
        this.isSearching = false;
        this.page = 1;
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/employees", {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.items = response.data.employees
            this.meta = response.data.meta
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }  
    },
  },
  watch: {
    searchKeyWord(newValue) {
      this.search(newValue)
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/employees", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.items = response.data.employees
        this.meta = response.data.meta
      }).catch(error => {
        this.errorNotify(error.response)
      })


    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/companies_all", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        response.data.forEach(row =>{
          this.companyTypes.push(
            {'value': row.id, 'label': row.name}
          )
          this.employee = response.data
        })
      }).catch(error => {
        this.errorNotify(error.response)
      })


  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
<style scoped>
.tablewrapper{
  overflow-x: scroll;
}
.table-scroll{
  border-collapse: collapse;
  white-space: nowrap;
}
.red{
  color: red
}
</style>
